<script>

    import { timeFormat } from 'd3';

    let { dateFloor, dateCeil } = $props();
    let tickwidth = $state();
    const ticks = [-3, -2, -1, 0, 1, 2, 3];
    const min = Math.min(...ticks);
    const max = Math.max(...ticks);
    const span = max - min;

    const abbrevs = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
    const formLegendLabel = (floor, ceil) => {
        const fMonth = timeFormat('%m')(floor);
        const cMonth = timeFormat('%m')(ceil);
        const fDay = timeFormat('%-d')(floor);
        const cDay = timeFormat('%-d')(ceil);
        if (fMonth != cMonth) {
            return `${abbrevs[+fMonth - 1]} ${fDay}–${abbrevs[+cMonth - 1]} ${cDay}`
        } else {
            return `${abbrevs[+fMonth - 1]} ${fDay}–${cDay}`
        }
    }

    let dateLabel = $derived(formLegendLabel(dateFloor, dateCeil))

    $inspect(timeFormat('%b')(dateFloor))

</script>
<div class="legend-container">
    <p class="legend-title">Sea surface temperature anomaly, {dateLabel}</p>
    <div class="legend-bar"></div>
    <div class="legend-ticks" bind:clientWidth={tickwidth}>
        {#if tickwidth}
            {#each ticks as tick, i}
                {@const pct = ((tick - min) / span) * 100}
                {@const isLast = i === ticks.length - 1}
                {@const left = i === 0 ? `${pct}%` : isLast ? `calc(${pct}% - 14px)` : tick === 0 ? `calc(${pct}% - 3px)` : `calc(${pct}% - 6px)`}
                {@const tickLeft = isLast ? `calc(${pct}% - 1px)` : `${pct}%`}
                {@const plus = tick > 0 ? '+' : ''}
                {@const unit = isLast ? '°C' : ''}
                <span class="tick" style="left:{tickLeft}; top: 0px;"></span>
                <span class="tick-text" style="left:{left}; top: 6px;">{plus}{tick}{unit}</span>
            {/each}
        {/if}
    </div>
</div>
<style lang='scss'>
    .legend-container {
        max-width: 320px;
        width: 100%;
        margin-inline:auto;
        @media #{$mobile} {
                margin-inline: none;
            }
    }
    .legend-bar {
        height: 12px;
        background: linear-gradient(to right,
  #3a54a4 0%, #6297c6 12.5%, #aad8e9 27.5%, #eaf7e6 42.5%,
  #feffc0 50%, #feea9f 57.5%, #fdad60 72.5%, #e95538 87.5%, #bd1726 100%);
  @media #{$mobile} {
                width: 95%;
            }
    }
    .legend-title {
        font-weight: 500;
        margin-bottom: 3px;
        font-size: 13px;
        @media #{$mobile} {
                
            }
        
    }
    .legend-ticks {
        position: relative;
        height: 25px;
        @media #{$mobile} {
                width: 95%;
            }
    }
    .tick-text {
        position: absolute;
        font-size: 12px;
        color: #666;
    }
    .tick {
        width: 1px;
        border-left: 1px solid #999;
        height: 4px;
        position: absolute;
    }
    
</style>